import React from 'react';
import 'twin.macro';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import request from '@teetsh/app/src/utils/request';
import { useTranslation } from 'react-i18next';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { NOTES_TRASH_KEY } from '@teetsh/app/src/containers/UserSettings/Trash/Notes/useNotesTrash';
import notesKeys from '@teetsh/app/src/containers/Dashboard/Todolist/queries/keys';

export function useRestoreNote() {
  const { notifySuccess, notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['userSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: ({
      id,
      schoolyearId,
      schoolId,
    }: {
      id: string;
      schoolyearId: string;
      schoolId: string;
    }) =>
      request(
        `/schoolyears/${schoolyearId}/schools/${schoolId}/notes/${id}/restore`,
        { method: 'PATCH' },
      ),
    onSuccess: (_, { schoolyearId, schoolId }) => {
      queryClient.invalidateQueries({
        queryKey: [NOTES_TRASH_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: notesKeys.all(schoolyearId, schoolId),
      });
      notifySuccess({
        title: t('userSettings:restore.messages.success'),
        message: (
          <ButtonLink
            outlined
            intent="success"
            to={`/annee-scolaire/${schoolyearId}/ecole/${schoolId}/dashboard`}
          >
            {t('userSettings:restore.messages.see')}
          </ButtonLink>
        ),
      });
    },
    onError: () => {
      notifyError({ title: t('userSettings:restore.messages.error') });
    },
  });
  return mutateAsync;
}
